import Amax from '@amax/amaxjs'
import AnchorLink, {APIError, ChainId, IdentityProof, LinkChannelSession, LinkSession} from '@amax/anchor-link'
import AnchorLinkBrowserTransport from '@amax/anchor-link-browser-transport'
import {StorageHelper} from "@/utils/storage";
import { transact } from './transact';

let _getClient = null
console.log('chainId---', import.meta.env.VITE_APP_NETWORK_chainId)

export const network = {
    blockchain: 'amax',
    expireInSeconds: 600,
    host: import.meta.env.VITE_APP_NETWORK_host, // ( or null if endorsed chainId )
    port: import.meta.env.VITE_APP_NETWORK_port, // ( or null if defaulting to 80 )
    chainId: import.meta.env.VITE_APP_NETWORK_chainId, // Or null to fetch automatically ( takes longer )
    protocol: import.meta.env.VITE_APP_NETWORK_protocol
}



export const blockchains = [
  {
      chainId: network.chainId,
      name: network.blockchain,
      rpcEndpoints: [
          {
              protocol: network.protocol,
              host: network.host,
              port: 0,
          },
      ],
  },
];

const options = {
    broadcast: false,
    sign: true,
    expireInSeconds: 200,
    chainId: network.chainId
}

export const scope = 'amax.scan';
export const isAPLink = window.navigator.userAgent
    .toLowerCase()
    .includes('aplink');

export async function getClient() {
    // if (_getClient) return _getClient;
    const scatter = getScatter();
    if (scatter) {
        if (!(window as any).scatterAMAX) {

            const identity = await scatter.getIdentity({
                accounts: [{chainId: network.chainId, blockchain: network.blockchain}],
            });
            const account = identity?.accounts[0];
            (window as any).scatterAMAX = scatter.amax(
                network,
                Amax,
                {
                    ...options,
                    authorization: [`${account.name}@${account.authority}`],
                },
                network.protocol
            );
        }
        _getClient = (window as any).scatterAMAX;
        return _getClient;
    }

    /**
     * 有些数据不需要连接钱包，也可以展示
     */
    if (!(window as any).AMAX) {
        (window as any).AMAX = Amax({
            httpEndpoint: `${network.protocol}://${network.host}`,
            chainId: network.chainId
        })
    }
    _getClient = (window as any).AMAX
    return _getClient
}

export function getScatter() {
    return (window as any).scatter
}


export function getLocalClient() {
    const client = Amax({
        httpEndpoint: `${network.protocol}://${network.host}`,
        chainId: network.chainId,
    });
    return client;
}
export async function getContract(contract) {
  const client = await getClient();
  return await client.contract(contract);
}

export function initLink() {
    if (!(window as any).__LINK__) {
        const transport = new AnchorLinkBrowserTransport();
        const link = new AnchorLink({
            transport,
            service: 'https://fwd.aplink.app', // 'ws://192.168.80.152:7001', // 'http://fwd.aplink.app', //
            chains: [
                {
                    chainId: network.chainId,
                    nodeUrl: `${network.protocol}://${network.host}`,
                },
            ],
        });

        link.restoreSession(scope).then(session => {
            console.log('session', session);
        });

        (window as any).__LINK__ = link;
        onAppRemoveSession();
    }
    return (window as any).__LINK__;
}

export async function onAppRemoveSession() {
    if (!(window as any).__LINK__) {
        return;
    }

    const session: LinkSession = await (window as any).__LINK__.restoreSession(scope);
    if (session) {
        (session as LinkChannelSession).onAppRemoveSession(() => {
            StorageHelper.removeItem('walletAddress');
            StorageHelper.removeItem('authority');
            StorageHelper.removeItem('chainId');
            (window as any).__LINK__.clearSessions(scope);
            window.location.reload();
        });
    }
}

export async function verifyProof(link, identity) {
    // Generate an array of valid chain IDs from the demo configuration
    const chains = blockchains.map(chain => chain.chainId);

    // Create a proof helper based on the identity results from anchor-link
    const proof = IdentityProof.from(identity.proof);

    // Check to see if the chainId from the proof is valid for this demo
    const chain = chains.find(id => ChainId.from(id).equals(proof.chainId));
    if (!chain) {
        throw new Error('Unsupported chain supplied in identity proof');
    }

    // Load the account data from a blockchain API
    // let account: API.v1.AccountObject;
    let account = null;
    try {
        account = await link.client.v1.chain.get_account(proof.signer.actor);
    } catch (error) {
        if (error instanceof APIError && error.code === 0) {
            throw new Error('No such account');
        } else {
            throw error;
        }
    }

    // Retrieve the auth from the permission specified in the proof
    const auth = account.getPermission(proof.signer.permission).required_auth;

    // Determine if the auth is valid with the given proof
    const valid = proof.verify(auth, account.head_block_time);

    // If not valid, throw error
    if (!valid) {
        throw new Error('Proof invalid or expired');
    }

    // Recover the key from this proof
    const proofKey = proof.recover();

    // Return the values expected by this demo application
    return {
        account,
        proof,
        proofKey,
        proofValid: valid,
    };
}

export function getActionParamsByType(
  structs: any[],
  type: string,
  obj = {},
): string {
  const field = structs.find(item => item.name === type);
  if (field) {
    for (const item of field.fields) {
      try {
        obj[item.name] = JSON.parse(
          getActionParamsByType(structs, item.type, obj[item.name]),
        );
      } catch (e) {
        obj[item.name] = getActionParamsByType(
          structs,
          item.type,
          obj[item.name],
        );
      }
    }
    return JSON.stringify(obj);
  } else {
    if (type.endsWith('[]')) {
      const arrType: string = type.split('[]')[0];
      const arr: string[] = [];
      try {
        arr.push(JSON.parse(getActionParamsByType(structs, arrType, obj)));
      } catch (e) {
        arr.push(getActionParamsByType(structs, arrType, obj));
      }

      return JSON.stringify(arr);
    } else {
      return type;
    }
  }
}


export async function serialization(account,contractFn,buffer){
  const client = await getClient();
  const contract = await client.contract(account);

  // {issuer: "testmulsign1", wallet_id: "0", mulsigner: "solo11111111", weight: 1}
  const data = contract.fc.fromBuffer(
    contractFn, // 合约方法
    Buffer.from(
      // 方法对应的系列化字符串
      buffer,
      "hex",
    ),
  );
  return data

}


export async function createrNFT(list) {
  const actions = []
  list.forEach(item => {
    actions.push({
      account:item.contract,
      name: item.name,
      data: item.data
    })
  });
  await transact(actions)
}

// 解析useAgent: mozilla/5.0 (macintosh; intel mac os x 10_15_7) applewebkit/537.36 (khtml, like gecko) chrome/120.0.0.0 safari/537.36{"aplink":"1.9.3","lang":"zh_cn"}
export default function getAPLinkInfo():
  | { aplink: string; lang: string; version: number[] }
  | undefined {
  const nav = window.navigator.userAgent.toLowerCase();
  if (nav.includes('aplink')) {
    const index = nav.indexOf('{');
    if (index > -1) {
      const json = nav.slice(index, nav.length);
      const obj = JSON.parse(json);
      obj['version'] = obj['aplink'].split('.').map(Number);
      return obj;
    }
  }
}
